import { useEffect } from 'react'

const MediaSession = ({
  artist,
  artwork,
  onPause,
  onNextTrack,
  onPlay,
  onPreviousTrack,
  onSeekBackward,
  onSeekForward,
  title,
}) => {
  const { mediaSession } = navigator

  useEffect(() => {
    mediaSession.metadata = new MediaMetadata({
      title,
      artist,
      artwork: [
        {
          src: artwork,
          type: 'image/png',
        },
      ],
    })

    return () => {
      mediaSession.metadata = null
    }
  }, [artist, artwork, title])

  useEffect(() => {
    mediaSession.setActionHandler('play', onPlay)

    return () => {
      mediaSession.setActionHandler('play', null)
    }
  }, [onPlay])

  useEffect(() => {
    mediaSession.setActionHandler('pause', onPause)

    return () => {
      mediaSession.setActionHandler('pause', null)
    }
  }, [onPause])

  useEffect(() => {
    mediaSession.setActionHandler('seekbackward', onSeekBackward)

    return () => {
      mediaSession.setActionHandler('seekbackward', null)
    }
  }, [onSeekBackward])

  useEffect(() => {
    mediaSession.setActionHandler('seekforward', onSeekForward)

    return () => {
      mediaSession.setActionHandler('seekforward', null)
    }
  }, [onSeekForward])

  useEffect(() => {
    mediaSession.setActionHandler('previoustrack', onPreviousTrack)
    return () => {
      mediaSession.setActionHandler('previoustrack', null)
    }
  }, [onPreviousTrack])

  useEffect(() => {
    mediaSession.setActionHandler('nexttrack', onNextTrack)

    return () => {
      mediaSession.setActionHandler('nexttrack', null)
    }
  }, [onNextTrack])

  return <></>
}

export default MediaSession
